// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"7ac59665","156":"ef82747a","437":"aa2e887a","485":"bcc3d70f","848":"effb6d34","914":"7f7ff955","966":"a523af21"}[chunkId] + ".chunk.css";
};